import purchaseType from '@/api/purchase-order/purchase-type'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
}

export const mutations = {
	...baseMutations,
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				filter: {
					search: context.state.search,
				}
			},
			attrubutes
		)
		return purchaseType.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return purchaseType.store(data)
	},
	update(context, { id, data }) {
		return purchaseType.update(id, data)
	},
	async find(context, id) {
		if (_.isEmpty(context.state.edit_data)) {
			let response = await purchaseType.find(id)
			context.commit('SET_EDIT_DATA', response.data)
		}
	},
	destroy(context, id) {
		return purchaseType.destroy(id)
	},
}
